/**
 * API URL resolver for Marge Auto.
 * Uses relative paths so /api calls go to the same domain.
 * Works on both preview (*.preview.emergentagent.com) and production (marge-auto.com).
 */
function getApiUrl() {
  if (typeof window !== 'undefined') {
    // Always use relative paths — Kubernetes ingress routes /api to backend
    return '';
  }
  return process.env.REACT_APP_BACKEND_URL || '';
}

export const API_URL = getApiUrl();
